module.exports = __webpack_public_path__ + "img/finsos-logo.64b8014c.png";